import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CalendarSettingsLayer from "../components/CalendarSettingsLayer";

const CalendarSettingsPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="הגדרות - יומן" />

                {/* CalendarSettingsLayer */}
                <CalendarSettingsLayer />
            </MasterLayout>
        </>
    );
};

export default CalendarSettingsPage; 